import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import * as $ from 'jquery';
import { RolesListComponent } from './roles-list.component';
import { RolesService } from './roles.service';
import { RolePermissions } from '../menu/role.permissions.model';
import { RoleList } from './role-list';
import { Router } from '@angular/router';
import { IRol } from './rol';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'pm-role-permissions',
  templateUrl: './role-permissions.component.html',
  styleUrls: ['./role-permissions.component.sass'],
  providers: [RolesService]
})
export class RolePermissionsComponent implements OnInit, OnDestroy, AfterViewInit {
  rolePermissionsList: Array<RoleList>;
  error: boolean;
  errorMessage = '';
  rolePermissions: RolePermissions;
  role: IRol;

  constructor(
    public service: RolesService,
    private router: Router,
    private parent: RolesListComponent,
    private spinnerService: NgxSpinnerService
  ) {}

  ngOnInit() {
    this.spinner();
    this.rolePermissionsList = new Array<RoleList>();
    console.log('OnInit: roleId: ', this.parent.editnumber);
    this.service.getRol(this.parent.editnumber).subscribe(res => (this.role = res));
    this.getRolPermissions(this.parent.editnumber);
  }

  ngAfterViewInit() {
    $('a[rel=roles]').addClass('selected');
  }

  editRolePermissions(elemento) {
    console.log('editRolePermissions: edit:' + elemento.parent.editnumber);
    console.log('editRolePermissions: elemento:' + JSON.stringify(this.rolePermissionsList));

    // let formData = '{';
    let roleList: RoleList;
    // let isValid = false;

    this.rolePermissions = new RolePermissions();
    for (let i = 0; i < this.rolePermissionsList.length; i++) {
      roleList = this.rolePermissionsList[i];
      switch (roleList.key) {
        case 'admin':
          this.rolePermissions.admin = roleList.value;
          break;
        case 'binCatalog':
          this.rolePermissions.binCatalog = roleList.value;
          break;
        case 'cardBrandCatalog':
          this.rolePermissions.cardBrandCatalog = roleList.value;
          break;
        case 'cardIssuerCatalog':
          this.rolePermissions.cardIssuerCatalog = roleList.value;
          break;
        case 'merchantCatalog':
          this.rolePermissions.merchantCatalog = roleList.value;
          break;
        case 'monitor':
          this.rolePermissions.monitor = roleList.value;
          break;
        case 'posCatalog':
          this.rolePermissions.posCatalog = roleList.value;
          break;
        case 'promotions':
          this.rolePermissions.promotions = roleList.value;
          break;
        case 'reports':
          this.rolePermissions.reports = roleList.value;
          break;
        case 'routing':
          this.rolePermissions.routing = roleList.value;
          break;
        default:
          break;
      }
    }

    console.log('rolePermissions: ', this.rolePermissions);

    return this.service.updateRolePermissions(elemento.parent.editnumber, this.rolePermissions).subscribe(
      res => {
        console.log('editRolePermissions: res: ', res);
        // this.router.navigate(['/roles']);
        this.parent.showRoles = true;
        this.parent.showAddRol = false;
        this.parent.showEditRol = false;
        this.parent.showEditRolPermissions = false;
      },
      error => {
        console.log('error: ', error.error.message);
        this.error = true;
        this.errorMessage = error.error.message;
      }
    );
  }

  getRolPermissions(roleId: number) {
    this.service.getRolePermissions(roleId).subscribe(
      res => {
        console.log('getRolPermissions: res: ', res);
        this.rolePermissions = res;
        console.log('getRolPermissions: rolPermissions: ', JSON.stringify(this.rolePermissions));

        // this.rolePermissionsList.push(new RoleList('admin', this.rolePermissions.admin));
        this.rolePermissionsList.push(new RoleList( 'BIN', 'binCatalog', this.rolePermissions.binCatalog));
        this.rolePermissionsList.push(new RoleList('Marcas de Tarjeta' , 'cardBrandCatalog', this.rolePermissions.cardBrandCatalog));
        this.rolePermissionsList.push(new RoleList('Emisores' , 'cardIssuerCatalog', this.rolePermissions.cardIssuerCatalog));
        this.rolePermissionsList.push(new RoleList('Sucursales' , 'merchantCatalog', this.rolePermissions.merchantCatalog));
        this.rolePermissionsList.push(new RoleList('Monitoreo' , 'monitor', this.rolePermissions.monitor));
        this.rolePermissionsList.push(new RoleList('Puntos de Venta' , 'posCatalog', this.rolePermissions.posCatalog));
        this.rolePermissionsList.push(new RoleList('Promociones' , 'promotions', this.rolePermissions.promotions));
        this.rolePermissionsList.push(new RoleList('Reportes' , 'reports', this.rolePermissions.reports));
        this.rolePermissionsList.push(new RoleList('Ruteo' , 'routing', this.rolePermissions.routing));
      },
      error => (this.errorMessage = error as any)
    );
  }

  cancelEditRolePermissions(): void {
    this.parent.showRoles = true;
    this.parent.showAddRol = false;
    this.parent.showEditRol = false;
    this.parent.showEditRolPermissions = false;
  }

  public spinner(): void {
    this.spinnerService.show();
    setTimeout(() => {
      this.spinnerService.hide();
    }, 300);
  }

  ngOnDestroy() {
    $('a[rel=roles]').removeClass('selected');
  }
}
